import type { Check } from './safeJournalApi';

/**
 * 순회점검일지의 기본 점검표 (V527 · DOC-122 §9) — 사용자가 준 순회점검일지 양식(2026-10-23 · 2일에 1회)의 현장 순회 점검 내용.
 *
 * <p>정본은 서버의 양식 표(V535 · {@code safe_patrol_template_items})다 — 안전보건팀 · 최고관리자가 [양식 편집] 으로
 * 고친다. 이 목록은 서버가 아직 옛 판일 때(양식 API 404) 새 일지를 띄우는 대신일 뿐이고, 저장할 때 서버가 양식으로 다시 짠다.
 */
const DEFAULT_ITEMS: Array<[string, string]> = [
  ['인원', '작업 중 근로자 안전보호구 착용상태는 양호한가?'],
  ['인원', '작업방법 및 신호 등에 관하여 충분히 검토(교육)하였는가?'],
  ['인원', '작업장 정리정돈은 잘 되었는가?'],
  ['인원', '작업자의 불안전한 행동은 없는가?'],
  ['화재', '화기 사용 장소 인근에 소화기 및 소화기구를 비치하였는가?'],
  ['중기', '차량계 건설기계 및 중장비 작업 시 신호수 배치는 하였는가?'],
  ['추락', '추락부위의 추락방지를 위한 안전난간을 설치하였는가?'],
  ['추락', '작업 시 작업발판은 견고하게 설치하였는가?'],
  ['추락', '추락, 낙하물방지망은 설치하였는가?'],
  ['추락', '고소 작업 시 안전대 착용은 하였는가?'],
  ['환경', '공사 중 주변에 인접한 도로나 건물에 피해를 주지는 않는가?'],
  ['환경', '위험물 보관소에 잠금장치를 하였는가?'],
  ['환경', '분진, 비산의 방지 조치를 하였는가?'],
  ['중량물', '양중 및 인양 작업 시 와이어나 고리작업은 하였는가?'],
  ['낙하비래', '작업 중 낙하 및 비래 위험은 없는가?'],
  ['전기', '분전반, 용접기 등의 청결, 보수 관리는 잘되고 있는가?'],
  ['전기', '전기기구는 누전차단기가 설치된 선로의 것을 사용하는가?'],
  ['전기', '배선의 벗겨짐이 없는가?'],
  ['기타', '현장 주변에 안전조치를 하였는가?'],
  ['기타', '출입 방지 시설은 관계자 외 쉽게 들어올 수 없는 구조로 하였는가?'],
];

export function defaultChecks(): Check[] {
  return DEFAULT_ITEMS.map(([category, item]) => ({ category, item, result: null }));
}
